import { render, staticRenderFns } from "./delete_cate.vue?vue&type=template&id=4a037c8e&scoped=true"
import script from "./delete_cate.vue?vue&type=script&lang=js"
export * from "./delete_cate.vue?vue&type=script&lang=js"
import style0 from "./delete_cate.vue?vue&type=style&index=0&id=4a037c8e&prod&lang=css"
import style1 from "./delete_cate.vue?vue&type=style&index=1&id=4a037c8e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a037c8e",
  null
  
)

export default component.exports